import FormSend from "./form-send";
export default FormSend;
